export default __webpack_public_path__ + "static/media/apenft.cbc872d7.jpeg";